import type { ModelProperty, ViewConfigField } from '@salescore/core'
import { Array, pipe } from 'effect'

import { useCurrentNodeModels, useCurrentSheet } from '../recoil/view/selectors/kpiFormSelector'
import { useModelSearcher } from '../recoil/view/selectors/modelSearcherSelector'

export const useCurrentFields = (): Array<{
  field: ViewConfigField
  nodePathAsLabel: string[]
  modelProperty: ModelProperty
}> => {
  const currentSheet = useCurrentSheet()
  const modelSearcher = useModelSearcher()
  const nodes = useCurrentNodeModels(currentSheet.tree)
  const currentFields = pipe(
    currentSheet.fields ?? [],
    Array.flatMapNullishOr((field) => {
      const model = modelSearcher.searchPropertyWithModel(field.property.modelName, field.property.propertyName)
      if (model === undefined) {
        return // undefinedでいいだろうか？
      }
      const node = nodes.find(({ node }) => node.name === field.property.nodeName)
      if (node === undefined) {
        return
      }
      return {
        field,
        nodePathAsLabel: node.nodePathAsLabel,
        modelProperty: model.property,
      }
    }),
  )

  return currentFields
}
